import { Breakpoint, Color, Popup, Shape, Typography } from '@elearning-platform/ui';
import { styled } from 'styled-components';

import { AppZIndex } from '../../enums';

export const StyledPopup = styled(Popup)`
  position: relative;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ShapeContainer = styled.div`
  width: 40%;
`;

export const StyledShape = styled(Shape)`
  position: absolute;
  width: 254px;
  height: 254px;
  right: -127px;
  bottom: 10px;
  z-index: ${AppZIndex.Min};
`;

export const FormWrapper = styled.div`
  position: relative;
  z-index: ${AppZIndex.PasswordForm};

  @media ${Breakpoint.Tablet} {
    max-width: 455px;
  }
`;

export const StyledTypography = styled(Typography)`
  color: ${Color.Gray500};
`;
